// eslint-disable-next-line import/prefer-default-export
export const CUSTOMER_ITEM_HEIGHT = 38;
